'use client'

import { Button } from '@graftcode/design-system'

import styles from './DialogFooter.module.scss'

interface DialogFooterProps {
  cancelLabel: string
  confirmLabel: string
  confirmVariant?: 'primary' | 'danger'
  disabled?: boolean
  onCancel: () => void
  onConfirm?: () => void
}

export function DialogFooter({
  cancelLabel,
  confirmLabel,
  confirmVariant = 'primary',
  disabled,
  onCancel,
  onConfirm,
}: DialogFooterProps) {
  const isSubmit = !onConfirm

  return (
    <div className={styles.root}>
      <Button type="button" variant="outlined" size="m" className={styles.button} onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button
        type={isSubmit ? 'submit' : 'button'}
        variant={confirmVariant}
        size="m"
        className={styles.button}
        disabled={disabled}
        onClick={onConfirm}
      >
        {confirmLabel}
      </Button>
    </div>
  )
}
